/* unplugin-vue-components disabled */import script from "./PriceCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceCalendar.vue?vue&type=script&setup=true&lang=js"

import "./PriceCalendar.vue?vue&type=style&index=0&id=75d8e623&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d8e623"]])

export default __exports__